let nextId = 0;
export function getUniqueId() {
    return `id-${nextId++}`;
}
